import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const DEPZDRAV_EXPORT_ENDPOINTS = {
  DOWNLOAD: {
    method: 'get',
    url: `${SERVER_API}/ttp-registries/person/depzdrav/xml-forming/download`,
  } as IEndpointData,
  GENERATE: {
    method: 'post',
    url: `${SERVER_API}/ttp-registries/person/depzdrav/xml-forming`,
  } as IEndpointData,
  HISTORY: {
    method: 'get',
    url: `${SERVER_API}/ttp-registries/person/depzdrav/xml-forming`,
  } as IEndpointData,
  GET_LAST: {
    method: 'get',
    url: `${SERVER_API}/ttp-registries/person/depzdrav/xml-forming/last`,
  } as IEndpointData,
};
